<app-progress-bar
  [progress]="fileUploadService.progress"
  [selectedLayout]="'dense'"
></app-progress-bar>
<!-- Navigation -->
<fuse-vertical-navigation
  class="dark z-1000 bg-gray-900 print:hidden"
  [appearance]="navigationAppearance"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->

  <ng-container fuseVerticalNavigationHeader>
    <div class="mb-5 flex h-20 items-center justify-between p-6 pb-0">
      @if (navigationAppearance === 'default' || isHover === true) {
        <div>
          <app-rtis-logo [animated]="true" theme="light" width="10em"></app-rtis-logo>
        </div>
      }

      <button
        class="-ml-1 hidden md:inline-flex"
        mat-icon-button
        (click)="toggleNavigationAppearance()"
      >
        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button>
    </div>
  </ng-container>

  @if (currentPlan) {
    <div fuseVerticalNavigationFooter class="flex items-center border-t p-6">
      @if (navigationAppearance === 'default' || isHover === true) {
        <p class="font-medium">{{ 'Current Plan' | transloco }}: {{ currentPlan | transloco }}</p>
      }
      @if (currentPlan === 'Advanced' || currentPlan === 'Premium') {
        <mat-icon
          [svgIcon]="'crown'"
          class="ml-2"
          [ngClass]="currentPlan === 'Advanced' ? 'text-gray-300' : 'text-amber-500'"
        ></mat-icon>
      }
    </div>
  }
</fuse-vertical-navigation>

<!-- Wrapper -->
<div fuseGlassGlow="ocean" class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Top Route Loading Progress Bar -->
  @if (routeLoadingService.isLoading()) {
    <div class="fixed top-0 left-0 right-0 z-99999 h-1 overflow-hidden bg-indigo-950/20">
      <div
        class="route-loading-progress-bar h-full bg-gradient-to-r from-indigo-500 via-purple-500 to-indigo-500 shadow-sm"
      ></div>
    </div>
  }

  <!-- Header -->
  <div
    class="shadow-lg sticky top-0 z-999 flex h-16 w-full flex-0 items-center px-4 print:hidden sm:z-99 md:px-6 backdrop-blur-md"
  >
    <div class="flex items-center bg-gray-700 rounded-full">
      <!-- Navigation toggle button -->
      <button class="md:hidden" mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:menu'" class="text-white"></mat-icon>
      </button>
      @if (organizationLogo) {
        <div
          class="mr-2 hidden h-10 w-10 items-center justify-center bg-gray-100 sm:flex rounded-full overflow-hidden ring-[3px] ring-white"
        >
          <img
            referrerpolicy="no-referrer"
            [src]="organizationLogo"
            class="h-full w-full object-contain"
            alt="logo"
          />
        </div>
      }
      @if (organizationName) {
        <span
          class="text-lg font-semibold p-2 text-white mr-3"
          [ngClass]="!organizationLogo ? 'ml-3' : ''"
        >
          {{ organizationName }}
        </span>
      }

      <!-- Navigation appearance toggle button -->
    </div>
    <!-- Components -->
    <div
      class="ml-auto flex items-center space-x-0.5 sm:space-x-3 bg-gray-700 rounded-r-full"
      style="border-radius: 20px !important"
      id="header-components"
    >
      @if (organizationType === 'factory' || organizationType === 'brand') {
        <mat-select
          [value]="selectedLanguage"
          (selectionChange)="languageChanged($event)"
          class="w-32 text-white ml-3"
        >
          <mat-option value="en">English</mat-option>
          <mat-option value="zh">中文</mat-option>
        </mat-select>
      }

      @if (organizationType === 'factory' || organizationType === 'consultant') {
        <notifications></notifications>
      }

      <user class="flex h-full items-center justify-center"></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col relative">
    @if (routeLoadingService.isLoading()) {
      <div
        class="absolute inset-0 z-30 flex items-center justify-center bg-gray-900/10 dark:bg-black/20 backdrop-blur-[1px] pointer-events-none transition-opacity duration-200"
      >
        <div
          class="flex items-center space-x-3 rounded-xl bg-white/95 dark:bg-gray-800/95 px-5 py-3 shadow-2xl ring-1 ring-black/10 dark:ring-white/10"
        >
          <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-200">
            {{ 'Loading...' | transloco }}
          </span>
        </div>
      </div>
    }
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
</div>

<!-- Quick chat -->
